import { Sprout } from "lucide-react";

const QUICK = [
  { label: "Über uns", href: "#ueber-uns" },
  { label: "Vorstand", href: "#vorstand" },
  { label: "Wasser & Abwasser", href: "#wasser" },
  { label: "Termine", href: "#termine" },
  { label: "Galerie", href: "#galerie" },
  { label: "Rufnummern", href: "#rufnummern" },
  { label: "Mitglied werden", href: "#mitglied-werden" },
  { label: "Forum", href: "/forum" },
  { label: "Kontakt", href: "#kontakt" },
];

export default function Footer() {
  return (
    <footer className="bg-[#1A382B] pt-16 pb-8 grain relative" data-testid="footer">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 relative z-[2]">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
          <div>
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-full bg-[#F8F7F2] text-[#1A382B]">
                <Sprout size={18} strokeWidth={1.8} />
              </span>
              <span className="font-display text-2xl font-bold text-[#F8F7F2]">KGA Schönwald e.V.</span>
            </div>
            <p className="mt-4 max-w-xs text-sm leading-relaxed text-[#C4D2C8]">
              Kleingartenanlage „Schönwald“ in Berlin-Rosenthal – seit 1918 ein gepflegter Rückzugsort
              im Grünen am Rande Berlins.
            </p>
          </div>
          <div>
            <p className="font-jbm text-xs tracking-[0.25em] uppercase text-[#9DBFA9]">Schnellzugriff</p>
            <ul className="mt-4 grid grid-cols-2 gap-x-4 gap-y-2.5">
              {QUICK.map((q) => (
                <li key={q.href}>
                  <a href={q.href} className="text-sm text-[#C4D2C8] transition-colors hover:text-[#D4A359]" data-testid={`footer-link-${q.href.slice(1)}`}>
                    {q.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <p className="font-jbm text-xs tracking-[0.25em] uppercase text-[#9DBFA9]">Kontakt</p>
            <ul className="mt-4 space-y-2.5 text-sm text-[#C4D2C8]">
              <li>
                <a href="mailto:info@kga-schoenwald.de" className="transition-colors hover:text-[#D4A359]" data-testid="footer-mail-info">info@kga-schoenwald.de</a>
              </li>
              <li>
                <a href="mailto:Wasser@kga-schoenwald.de" className="transition-colors hover:text-[#D4A359]" data-testid="footer-mail-wasser">wasser@kga-schoenwald.de</a>
              </li>
              <li className="pt-2 text-[#9DBFA9]">
                Parzellenvergabe: KVA Berlin Mitte-Nord,<br />Herr Wittig · Tel. 030 2581 85 226
              </li>
            </ul>
          </div>
        </div>
        <div className="mt-12 flex flex-col sm:flex-row items-center justify-between gap-3 border-t border-white/10 pt-6">
          <p className="font-jbm text-xs tracking-wider text-[#9DBFA9]">© 2026 KGA Schönwald e.V. · Berlin-Rosenthal</p>
          <div className="flex items-center gap-5">
            <p className="hidden md:block font-display italic text-sm text-[#C4D2C8]">Natur erleben · Gemeinschaft pflegen</p>
            <a href="/impressum" data-testid="footer-impressum-link" className="font-jbm text-xs tracking-wider text-[#9DBFA9] transition-colors hover:text-[#D4A359]">
              Impressum
            </a>
            <a href="/datenschutz" data-testid="footer-datenschutz-link" className="font-jbm text-xs tracking-wider text-[#9DBFA9] transition-colors hover:text-[#D4A359]">
              Datenschutz
            </a>
            <a href="/admin" data-testid="footer-admin-link" className="font-jbm text-xs tracking-wider text-[#9DBFA9] transition-colors hover:text-[#D4A359]">
              Vorstands-Login
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
